import 'client-only';
import { buildClientFeatureFlagsV2 } from '@curology/feature-flags/client';

import { type Brand } from '@/consts/brands';
import { type AnalyticsEvent, type AnalyticsPayload } from '@/consts/events';
import { getUserContext } from '@/utils/featureFlags/actions';

import { type Flags, defaultFlagValues, jsonFlagValues } from './flags';

const {
  initLd,
  trackFeature,
  useFlags,
  useFlag,
  flushFeatureTracking,
  closeFeatureFlagClient,
} = buildClientFeatureFlagsV2<Flags, AnalyticsEvent, AnalyticsPayload>({
  enabled: typeof window !== 'undefined',
  defaultFlagValues,
  jsonFlagValues,
});

const getContext = async (brand: Brand) => {
  return await getUserContext(brand);
};

export {
  initLd,
  useFlags,
  useFlag,
  trackFeature,
  flushFeatureTracking,
  closeFeatureFlagClient,
  getContext,
};
